export function getCarouselArrowSize(isGreaterThanTablet: boolean) {
  return isGreaterThanTablet ? '3.2rem' : '1.8rem';
}
